import React from 'react'

import { Card } from '../../../components/card/card.js'
import { EsisTag, EsisTagProps } from '../../../components/esis-tag/esis-tag.js'
import { GridColumn } from '../../../components/grid/grid-column.js'
import { Grid } from '../../../components/grid/grid.js'
import { useCurrentBreakPoint } from '../../../components/helper/hooks/use-current-breakpoint.js'
import { LinkCard, LinkCardProps } from '../../../components/link-card/link-card.js'
import { PaymentCard, PaymentCardProps } from '../../../components/payment-card/payment-card.js'
import { ViewBase, ViewBaseProps } from '../../base/base.js'

export interface DashboardProps {
    title: string
    subtitle: string
    linkCards: LinkCardProps[]
    paymentCard: PaymentCardProps
    esisTag?: EsisTagProps
}

export const Dashboard = (props: DashboardProps): JSX.Element => {
    const bp = useCurrentBreakPoint()
    const shouldWrapInCard = bp ? !['xs', 'sm', 'md'].includes(bp) : true

    const redirectToUrlAfterLogin = localStorage.getItem('redirectToUrlAfterLogin')
    if (redirectToUrlAfterLogin) {
        localStorage.removeItem('redirectToUrlAfterLogin')
        window.location.href = redirectToUrlAfterLogin
    }

    const renderCard = () => (
        <Card hasContent={true} padding="medium" variant="quaternary">
            {renderContent()}
        </Card>
    )

    const renderContent = () => (
        <Grid align={['middle-xs']} gutter="large">
            <GridColumn width={['lg-7']}>
                <p className="text-large bold">{props.title}</p>
                <p className="text-title">{props.subtitle}</p>
            </GridColumn>
            <GridColumn width={['lg-5']}>
                <PaymentCard {...props.paymentCard} />
            </GridColumn>
        </Grid>
    )

    return (
        <div className="text">
            {shouldWrapInCard ? renderCard() : renderContent()}
            {props.esisTag && (
                <Grid equalHeight={true}>
                    <GridColumn width={['xl-7']}>
                        <EsisTag className="esis-tag__banner" {...props.esisTag} />
                    </GridColumn>
                    <GridColumn width={['xl-5']}>
                        <Grid className={shouldWrapInCard ? 'text__margin-double' : undefined} equalHeight={true}>
                            {props.linkCards.map((item: LinkCardProps, index: number) => (
                                <GridColumn width={index > 0 ? ['xs-2', 'xl-12'] : ['xl-12']} key={index}>
                                    <LinkCard {...item} />
                                </GridColumn>
                            ))}
                        </Grid>
                    </GridColumn>
                </Grid>
            )}
            {!props.esisTag && (
                <Grid className={shouldWrapInCard ? 'text__margin-double' : undefined} equalHeight={true}>
                    {props.linkCards.map((item: LinkCardProps, index: number) => (
                        <GridColumn width={index > 0 ? ['xs-2', 'xl-4'] : ['xl-4']} key={index}>
                            <LinkCard {...item} />
                        </GridColumn>
                    ))}
                </Grid>
            )}
        </div>
    )
}

export interface ViewDashboardProps extends ViewBaseProps {
    linkCards: LinkCardProps[]
    paymentCard: PaymentCardProps
}

export const ViewDashboard = (props: ViewDashboardProps): JSX.Element => {
    const bp = useCurrentBreakPoint()
    const shouldWrapInCard = bp ? !['xs', 'sm', 'md'].includes(bp) : true

    const renderCard = () => (
        <Card hasContent={true} padding="medium" variant="quaternary">
            {renderContent()}
        </Card>
    )

    const renderContent = () => (
        <Grid align={['middle-xs']}>
            <GridColumn width={['lg-7']}>
                <p className="text-large bold">Welcome,</p>
                <p className="text-title">Peter Blomkvist</p>
            </GridColumn>
            <GridColumn width={['lg-5']}>
                <PaymentCard {...props.paymentCard} />
            </GridColumn>
        </Grid>
    )

    return (
        <ViewBase {...props}>
            <div className="text">
                {shouldWrapInCard ? renderCard() : renderContent()}
                <Grid className={shouldWrapInCard ? 'text__margin-double' : undefined} equalHeight={true}>
                    {props.linkCards.map((item: LinkCardProps, index: number) => (
                        <GridColumn width={index > 0 ? ['xs-2', 'xl-4'] : ['xl-4']} key={index}>
                            <LinkCard {...item} />
                        </GridColumn>
                    ))}
                </Grid>
            </div>
        </ViewBase>
    )
}
